import React from 'react';
import QuestionnaireResultWithScoringDetailFileValue from './QuestionnaireResultWithScoringDetailFileValue';
import {
	isImageUrl,
	parseJson,
	ResultValue,
} from '../Helpers/QuestionnaireResultWithScoringDetailValueCell.helper';

interface Props {
	patientId: string;
	values: ResultValue[];
}

const SHAPE_IMAGES: Record<string, string> = {
	circle:
		'https://cdn.meddi.com/meddiApp-assets/questionnaires/acer/circle.png',
	triangle:
		'https://cdn.meddi.com/meddiApp-assets/questionnaires/acer/triangle.png',
	square:
		'https://cdn.meddi.com/meddiApp-assets/questionnaires/acer/square.png',
};

const renderValue = (value: any, patientId?: string): React.ReactNode => {
	if (!value) return '-';

	if (typeof value === 'string') {
		const parsed = parseJson(value);

		if (parsed?.timedOut === true) {
			return (
				<div style={{ color: '#d32f2f', fontWeight: 600 }}>
					Časový limit pro odpověď vypršel.
				</div>
			);
		}

		if (parsed?.value) {
			if (isImageUrl(parsed.value)) {
				return (
					<img src={parsed.value} alt='Odpověď' style={{ maxWidth: '300px' }} />
				);
			}

			if (parsed.value === 'circle') {
				return <div style={{ fontWeight: 600 }}>Splněno</div>;
			}

			return parsed.value;
		}

		if (Array.isArray(parsed?.tapped)) {
			return (
				<div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
					{parsed.tapped.map((shape: string, index: number) => {
						const imageUrl = SHAPE_IMAGES[shape];
						if (!imageUrl) {
							return (
								<div key={`${shape}-${index}`} style={{ fontWeight: 600 }}>
									{shape}
								</div>
							);
						}
						return (
							<img
								key={`${shape}-${index}`}
								src={imageUrl}
								alt={shape}
								style={{ width: '48px', height: '48px', objectFit: 'contain' }}
							/>
						);
					})}
				</div>
			);
		}
		return <div style={{ fontWeight: 600 }}>{value}</div>;
	}

	if (value?.type === 'file' && value?.fileId) {
		return (
			<QuestionnaireResultWithScoringDetailFileValue
				fileId={value.fileId}
				patientId={patientId}
				transcription={value.transcription}
			/>
		);
	}

	if (typeof value === 'object') {
		return JSON.stringify(value);
	}

	return String(value);
};

const QuestionnaireResultWithScoringDetailValueCell: React.FC<Props> = ({
	values,
	patientId,
}) => {
	if (!values?.length) {
		return <>-</>;
	}

	return (
		<>
			{values.map((item, index) => (
				<div key={index}>{renderValue(item.value, patientId)}</div>
			))}
		</>
	);
};

export default QuestionnaireResultWithScoringDetailValueCell;
